import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";

const Layout = ({ username, onLogout }) => {
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("manager_activeTab") || "analytics";
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    useState(false);

  useEffect(() => {
    sessionStorage.setItem("manager_activeTab", activeTab);
  }, [activeTab]);



  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="flex min-h-screen">
        <Sidebar
          username={username}
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          onLogout={onLogout}
        />

        <MainContent
          activeTab={activeTab}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
    </div>
  );
};

export default Layout;